// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9acf43f","732":"65f07752","977":"59924391"}[chunkId] + ".chunk.js";
};